import { Card } from "../../tailwind/card";
import { STATUS_ICONS } from "./StatusIcons";

const LabelWithIcon = ({ icon, text }) => (
  <span className="inline-flex items-center gap-1">
    <span className="flex items-center justify-center h-4 w-4">{icon}</span>
    <span>{text}</span>
  </span>
);

const COLUMNS = [
  { key: 'date', label: 'Date', align: 'left', valueClass: 'text-gray-700 dark:text-gray-300' },
  { key: 'attempted', label: 'Attempted', align: 'right', valueClass: 'text-gray-600 dark:text-gray-400' },
  { key: 'sent', label: <LabelWithIcon icon={STATUS_ICONS.sent} text="Sent" />, align: 'right', valueClass: 'text-gray-900 dark:text-white' },
  { key: 'delivered', label: <LabelWithIcon icon={STATUS_ICONS.delivered} text="Delivered" />, align: 'right', valueClass: 'text-emerald-600 dark:text-emerald-400' },
  { key: 'read', label: <LabelWithIcon icon={STATUS_ICONS.read} text="Read" />, align: 'right', valueClass: 'text-blue-600 dark:text-blue-400' },
  { key: 'failed', label: <LabelWithIcon icon={STATUS_ICONS.failed} text="Failed" />, align: 'right', valueClass: 'text-red-600 dark:text-red-400' },
];

export const DailyBreakdown = ({ data, onRowClick }) => {
  const sortedData = data && data.length > 0 ? [...data] : [];
  const toLocaleStr = (val) => val?.toLocaleString?.() || val || 0;

  const handleDateClick = (date) => {
    if (onRowClick) {
      onRowClick(date);
    }
  };

  return (
    <Card className="border-gray-100 dark:border-slate-800 bg-white dark:bg-slate-900 h-full">
      <div className="p-6 border-b border-gray-100 dark:border-slate-800">
        <div className="flex items-start justify-between">
          <div>
            <h3 className="font-semibold text-gray-900 dark:text-white text-lg">Daily Message Logs</h3>
          </div>
          {/* <Badge variant="secondary" className="text-xs bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400 font-medium">Last 7 days</Badge> */}
        </div>
      </div>

      <div className="overflow-x-auto px-6">
        <table className="w-full table-auto">
          <colgroup>
            {COLUMNS.map((col) => (
              <col key={col.key} className={col.align === 'left' ? '' : 'text-right'} />
            ))}
          </colgroup>
          <thead>
            <tr className="border-b border-gray-100 dark:border-slate-800 bg-gray-50/50 dark:bg-slate-800/50">
              {COLUMNS.map((col) => (
                <th
                  key={col.key}
                  className={col.align === 'left' ? 'text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider px-4 py-4' : 'text-right text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider px-4 py-4'}
                >
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sortedData && sortedData.length > 0 ? (
              sortedData.map((row, i) => (
                <tr
                  key={i}
                  onClick={() => handleDateClick(row)}
                  className="border-b border-gray-50 dark:border-slate-800/50 hover:bg-gray-50/75 dark:hover:bg-slate-800/50 transition-colors"
                >
                  {COLUMNS.map((col) => (
                    <td key={col.key} className={col.align === 'left' ? 'px-4 py-4 text-left' : 'px-4 py-4 text-right'}>
                      <span className={`text-sm font-semibold ${col.valueClass}`}>
                        {col.key === 'date' ? row.date : toLocaleStr(row[col.key])}
                      </span>
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={COLUMNS.length} className="px-6 py-8 text-center text-gray-500 dark:text-gray-400">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </Card>
  );
};
